// Shared display helpers for the document portal.

export const STATUS_LABELS = {
  uploaded: 'Uploaded',
  received: 'Received',
  in_review: 'In Review',
  reviewed: 'Reviewed',
  accepted: 'Accepted',
  rejected: 'Rejected',
  needs_clarification: 'Needs Clarification',
  missing: 'Missing',
  signature_required: 'Signature Required',
  signed: 'Signed',
  filed: 'Filed',
  archived: 'Archived',
};

export const STATUS_TONES = {
  uploaded: 'bg-blue-100 text-blue-700 border border-blue-200',
  received: 'bg-indigo-100 text-indigo-700 border border-indigo-200',
  in_review: 'bg-amber-100 text-amber-700 border border-amber-200',
  reviewed: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  accepted: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
  rejected: 'bg-rose-100 text-rose-700 border border-rose-200',
  needs_clarification: 'bg-orange-100 text-orange-700 border border-orange-200',
  missing: 'bg-neutral-200 text-neutral-700 border border-neutral-300',
  signature_required: 'bg-fuchsia-100 text-fuchsia-700 border border-fuchsia-200',
  signed: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
  filed: 'bg-[#14110f] text-[#f5b300] border border-[#f5b300]/40',
  archived: 'bg-neutral-100 text-neutral-500 border border-neutral-200',
};

export const TAX_FILE_LABELS = {
  not_started: 'Not Started',
  awaiting_documents: 'Awaiting Documents',
  documents_received: 'Documents Received',
  in_review: 'In Review',
  questions_sent: 'Questions Sent',
  ready_for_preparation: 'Ready for Preparation',
  in_preparation: 'In Preparation',
  ready_for_signature: 'Ready for Signature',
  signature_pending: 'Signature Pending',
  ready_to_file: 'Ready to File',
  filed: 'Filed',
  completed: 'Completed',
  archived: 'Archived',
};

export const SIGNATURE_LABELS = {
  draft: 'Draft', sent: 'Sent', viewed: 'Viewed', signed: 'Signed',
  declined: 'Declined', expired: 'Expired', cancelled: 'Cancelled',
};

export function statusLabel(s) { return STATUS_LABELS[s] || s; }
export function statusTone(s) {
  return STATUS_TONES[s] || 'bg-neutral-100 text-neutral-700 border border-neutral-200';
}
export function bytesToHuman(n) {
  if (n === undefined || n === null) return '';
  const u = ['B', 'KB', 'MB', 'GB'];
  let i = 0; let v = n;
  while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v >= 10 || i === 0 ? 0 : 1)} ${u[i]}`;
}
export function fmtDateTime(s) {
  if (!s) return '';
  try {
    const d = new Date(s);
    return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  } catch { return s; }
}

export function downloadFromLink(link, baseUrl) {
  // link is a relative path like /api/files/<token>
  const full = `${baseUrl}${link}`;
  const a = document.createElement('a');
  a.href = full;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
